import { concat } from '@ember/helper';
import { service } from '@ember/service';
import AppHeaderBanner from './header/banner';
import { PhArrowSquareOut } from 'ember-phosphor-icons';
import Component from '@glimmer/component';
import TioHeaderMenuButton from 'tio-common/components/tio/header/menu-button';
import type SessionContextService from 'tio-employee/services/session-context';
import type SideDrawerService from 'tio-common/services/side-drawer';
import { t } from 'ember-intl';
import type PartnerService from 'tio-employee/services/partner';
interface AppHeaderSignature {
  Args: {
    /**
     * Brand Updates 2026 note 1 moves the partner logo into the side nav. Only
     * the banner moves — the partner link and the mobile menu button stay, or
     * they would simply vanish.
     */
    hideBanner?: boolean;
  };
  Element: HTMLHeadElement;
}
export default class AppHeaderComponent extends Component<AppHeaderSignature> {
  @service declare sessionContext: SessionContextService;
  @service declare sideDrawer: SideDrawerService;
  @service declare partner: PartnerService;
  toggleDrawer = () => {
    this.sideDrawer.toggleDrawer();
  };
  get partnerUrlString() {
    return this.partner.partnerUrlString;
  }
  get partnerName() {
    return this.partner.company?.name || '';
  }
  <template>
    <header class="isolate top-0 tio-bg-surface tio-fg-primary z-5" ...attributes>
      {{! Same gutter class the shell wraps the outlet in, so the menu button
          lines up with page content instead of tracking it by hand. }}
      <div class="tio-row-between app-page-gutter">
        {{! template-lint-disable simple-unless }}
        <TioHeaderMenuButton @onClick={{this.toggleDrawer}} class="lg:hidden" />
        {{#unless @hideBanner}}
          <AppHeaderBanner @company={{this.sessionContext.currentCompany}} />
        {{/unless}}
        {{#if this.partnerUrlString}}
          <div class="tio-flex-tight h-14 header-right text-sm items-end">
            <div class="tio-row-tight flex-row text-right">
              <p>{{t "instride.looking_for_coverage" partner=this.partnerName}}</p>
              <a
                class="tio-header-partner-link underline underline-offset-2 tio-fg-info hover:tio-fg-info-body tio-row-extra-tight"
                href={{this.partnerUrlString}}
                target="_blank"
                rel="noopener noreferrer"
              >{{concat this.partnerName " " (t "dashboard")}}<PhArrowSquareOut @size={{16}} /></a>
            </div>
          </div>
        {{/if}}
      </div>
    </header>
  </template>
}
